import { zodResolver } from '@hookform/resolvers/zod';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { IS_VALID_URL } from 'utils/validationRegex';
import { z } from 'zod';
import { TEST_PUSH_FORM_DEFAULT_VALUES } from '../constants';

const schema = z.object({
  browserToken: z.string().min(1, 'Browser token required to send test push'),
  title: z.string().min(1, 'Title required to send test push'),
  body: z.string().min(1, 'Body required to send test push'),
  icon: z.string().optional(),
  clickAction: z
    .string()
    .optional()
    .refine((url) => (url ? IS_VALID_URL.test(url) : true), 'Invalid URL'),
});

export type TestWebPushFormValues = z.infer<typeof schema>;

export const TestWebPushFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const methods = useForm<TestWebPushFormValues>({
    defaultValues: TEST_PUSH_FORM_DEFAULT_VALUES,
    mode: 'onChange',
    shouldUnregister: true,
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};

export const useTestWebPushFormContext = () => useFormContext<TestWebPushFormValues>();
